module.exports = __webpack_public_path__ + "static/media/daon.ea364f37.png";